module.exports = __webpack_public_path__ + "static/coding-e59f1f3a5fd704b9146f1dc23020bb00.svg";